import ReactDirective from "acl-ui/angular/reactDirective.umd";
import DownloadXlsModal from "@viz-ui/components/DownloadXlsModal";

angular
  .module("highbond.visualizer.downloadXlsModal", [])
  .directive("vizDownloadXlsModal", ReactDirective.getFactory(DownloadXlsModal));
